export const knowledgeLevel = [
  { id: '1', label: 'Técnico' },
  { id: '2', label: 'Graduação' },
  { id: '3', label: 'Pós-Graduação' },
  { id: '4', label: 'Mestrado' },
  { id: '5', label: 'Doutorado' },
  { id: '6', label: 'Pós-Doutorado' },
];
